import { promoCodeType } from "./type";

const initialAuthState = {
  promoCodes: null,
  promoCode: null,
  isLoading: false,
  statusCode: null
};

export const reducer = (state = initialAuthState, action) => {
  switch (action.type) {
    case promoCodeType.GET_PROMO_CODE_REQUEST:
      return { ...state, isLoading: true };
    case promoCodeType.GET_PROMO_CODE_SUCCESS:
      return { ...state, isLoading: false, promoCodes: action.payload.data };
    case promoCodeType.GET_PROMO_CODE_FAIL:
      return { ...state, isLoading: false, error: action.error };
    case promoCodeType.GET_SINGLE_PROMO_CODE_REQUEST:
      return { ...state, isLoading: true, statusCode: null };
    case promoCodeType.GET_SINGLE_PROMO_CODE_SUCCESS:
      return { ...state, isLoading: false, promoCode: action.payload };
    case promoCodeType.GET_SINGLE_PROMO_CODE_FAIL:
      return { ...state, isLoading: false, error: action.error, statusCode: action.statusCode };
    case promoCodeType.GET_DISTRIBUTOR_DROPDOWN_SUCCESS:
      return { ...state, isLoading: false, distributorDropdownList: action.payload.data };
    default:
      return state;
  }
};
